import React, { useState } from 'react'

import {
    Typography, Paper, TextField,
    Stack,
    Grid,
    Button,

    useMediaQuery,
    Snackbar,
    Alert,
} from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';

import { Box } from '@mui/system';


import { useDispatch, useSelector } from 'react-redux';
import { registerProfile } from '../redux/actions/userAction';

export default function EditProfile() {
    const matches = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            }
        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        cardDashboard: {
            borderRadius: 0,
            boxShadow: 0,
            minHeight: 90,
            opacity: 0.9
        },
        actionButton: {
            margin: 0,
            padding: 1,
            height: 23,
            backgroundColor: "#B9E291",
            boxShadow: 0,
            borderRadius: 0,
            fontSize: 12
        }
    }
    const user = useSelector(state => state.user);

    const dispatch = useDispatch();
    const [snack, setSnack] = useState(false);

    const [alert, setAlert] = useState({
        message: "This is an alert message.",
        severity: "success",
    })

    const handleSnack = () => {
        setSnack(false);
    }
    const [payload, setPayload] = useState({
        userFirstName: "",
        userLastName: "",
        userAddress: "",
        userEmail: "",
        userContact: "",
    });
    const handleChange = (prop) => (e) => {
        setPayload({ ...payload, [prop]: e.target.value });
    }

    const submitProfile = (e) => {
        e.preventDefault();
        if (!payload.userFirstName || !payload.userLastName || !payload.userAddress || !payload.userContact ) {
            setAlert({
                message: "Please make sure to fill in the empty fields.",
                severity: "warning"
            })
            setSnack(true)
        } else {
            dispatch(registerProfile(payload.userFirstName, payload.userLastName, payload.userAddress, user.currentEmail, payload.userContact))
        }
    }

    const vertical = "top";
    const horizontal = "center";


    return (
        <Box>
            <SEO title="Edit Profile - Baliwag Municipal Library" description="Admin Profile" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: "#280707", textAlign: "center" }}>It seems like you just created your account. Let's set up your profile!</Typography>
                    <Stack direction="column" spacing={2} sx={{ marginTop: 3 }}>
                        <Grid
                            container
                            columns={12}
                            spacing={3}
                            justifyContent="center"
                            sx={{
                                paddingLeft: matches ? "5%" : "10%",
                                paddingRight: matches ? "5%" : "10%",
                            }}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label='First Name'
                                    value={payload.userFirstName}
                                    onChange={handleChange('userFirstName')}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label='Last Name'
                                    value={payload.userLastName}
                                    onChange={handleChange('userLastName')}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label='Email Address'
                                    value={user.currentEmail}
                                    disabled
                                    onChange={handleChange('userEmail')}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label='Address'
                                    value={payload.userAddress}
                                    onChange={handleChange('userAddress')}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label='Contact'
                                    value={payload.userContact}
                                    onChange={handleChange('userContact')}
                                />
                            </Grid>
                        </Grid>
                        <Grid container justifyContent="center">
                            <Button
                                variant="contained"
                                onClick={submitProfile}
                                fullWidth
                                sx={{
                                    maxWidth: 250,
                                    textAlign: "center",
                                    backgroundColor: (theme) => theme.palette.error.main,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.error.light,

                                    },
                                }}>
                                Save Profile
                            </Button>
                        </Grid>
                    </Stack>
                </Box>
                <Box sx={{ height: 100 }} />
            </Paper>
            <Snackbar open={snack} autoHideDuration={6000} onClose={handleSnack} anchorOrigin={{ vertical, horizontal }}>
                <Alert onClose={handleSnack} severity={alert.severity} sx={{ width: '100%' }}>
                    {alert.message}
                </Alert>
            </Snackbar>
            <Box sx={style.footerStyle}>
                <Footer />
            </Box>
        </Box>
    )
}
